import '../../css/App.css'
import '../../css/ReplaceBatteries.css'
import '../../css/PageTemplate.css'
import {useContext, useEffect, useState} from 'react'
import {AppContext} from "../context/AppContext";
import {IAuth, IReplaceBatteriesFormInput} from '../../interfaces/interface';
import {IMessageSender, IMessageErrorResponse, IMessageResponse} from '../../interfaces/messageInterface';
import PopMessage from '../PopMessage/PopMessage';
import axios from 'axios';
import HeaderTemplate from '../HeaderTemplate';
import FormInternalDivTemplate from '../formTemplate/FormInternalDivTemplate';

function ReplaceBatteries() {

    const {navBarStatus, authorization, disMessage, navBarHandler, errorHandlerFunction} = useContext(AppContext);
    const [auth]: IAuth[] = authorization;
    const [isNavbarOpen] = navBarStatus;
    const navBarClickHandler: (e: any) => void = navBarHandler
    const [displayMessage]: string[] = disMessage;
    const [, setDisplayMessage]: React.Dispatch<React.SetStateAction<string>>[] = disMessage;
    const [formInput, setFormInput] = useState<IReplaceBatteriesFormInput>({
        assetName: "",
        deviceId: ""
    })
    const [formFieldsValid, setFormFieldsValid] = useState({
        isVaild: false,
        displayMessage: false,
        message: ""
    })
    const [sensorIdArr, setSensorIdArr] = useState<string[]>([])
    const [assetNamesArr, setAssetNamesArr] = useState<string[]>([])
    const [errorMessage, setErrorMessage] = useState<string>("")
    const errorHandler: (status: number) => string = errorHandlerFunction;

    const isDisabled = (): boolean => {
        if (displayMessage !== "none" || isNavbarOpen === true) return true
        return false
    }
    const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (formValidation()) {
            setDisplayMessage("asset-details");
        }
    }
    const formValidation = (): boolean => {
        let isValid = true
        if (formInput.deviceId === "") {
            setFormFieldsValid({
                isVaild: false,
                displayMessage: true,
                message: "Field cannot be empty"
            })
            isValid = false;

        }
        if (!formFieldsValid.isVaild) {
            isValid = false;
        }
        return isValid;
    }
    const replaceBatteriesHandler = (): void => {
        let messageBody: IMessageSender = {
            type: 'replaceBatteries',
            userId: auth.username,
            data: formInput.deviceId
        }
        setDisplayMessage("processing");
        axios.post('/message', messageBody, auth.header
        ).then(res => {
            if (res.data.status === "OK") {
                setDisplayMessage("done");
                clearFields();
            } else {
                setErrorMessage(res.data.errorDescription)
                setDisplayMessage("error");
            }
        }).catch(({response}: IMessageErrorResponse) => {
            const errorMessage = errorHandler(response.data.status)
            setErrorMessage(errorMessage)
            setDisplayMessage("error");
        })
    }
    const clearFields = () => {
        setFormInput({
            assetName: "",
            deviceId: ""
        })
        setFormFieldsValid({
            isVaild: false,
            displayMessage: false,
            message: ""
        })
    }
    const changeHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
        let input = e.target.value.toUpperCase();
        if (/^[0-9a-fA-F]+$/.test(input) || input === "") {
            setFormInput({
                ...formInput,
                deviceId: input
            })
            if (input.length >= 3) {
                let messageBody: IMessageSender = {
                    type: 'getDeviceIDs',
                    userId: auth.username,
                    deviceIdFilter: {
                        Type: "All",
                        Pattern: input
                    }
                }
                /*axios.post('/message',messageBody *//*For Cookie*/
                axios.post('/message', messageBody, auth.header
                ).then(res => {
                    if (res.data.status === "OK") {
                        setSensorIdArr(res.data.names);
                        if (res.data.names.includes(input)) {
                            setFormFieldsValid({
                                isVaild: true,
                                displayMessage: false,
                                message: ""
                            })
                        } else {
                            setFormFieldsValid({
                                isVaild: false,
                                displayMessage: false,
                                message: ""
                            })
                        }
                    } else {
                        setSensorIdArr([])
                        setFormFieldsValid({
                            isVaild: false,
                            displayMessage: true,
                            message: res.data.errorDescription
                        })
                    }
                }).catch(({response}: IMessageErrorResponse) => {
                    const errorMessage = errorHandler(response.data.status)
                    setErrorMessage(errorMessage)
                    setDisplayMessage("error");
                })
            } else {
                setSensorIdArr([])
                setFormFieldsValid({
                    isVaild: false,
                    displayMessage: false,
                    message: ""
                })
            }
        }
    };
    const assetNameChangeHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
        let input = e.target.value;
        if (!(/'/.test(input)) && !(/"/.test(input)) && !(/`/.test(input))) {
            setFormInput({
                ...formInput,
                assetName: input
            });
            if (input.length >= 3) {
                let messageBody: IMessageSender = {
                    type: 'getAssetNames',
                    userId: auth.username,
                    data: input
                }
                /*axios.post('/message',messageBody *//*For Cookie*/
                axios.post('/message', messageBody, auth.header
                ).then(res => {
                    if (res.data.status === "OK") {
                        setAssetNamesArr(res.data.names)

                        isDeviceIncludes(res.data.names, input);
                    } else {
                        setAssetNamesArr([])
                    }
                }).catch(({response}: IMessageErrorResponse) => {
                    const errorMessage = errorHandler(response.data.status)
                    setErrorMessage(errorMessage)
                    setDisplayMessage("error");
                })
            } else {
                setAssetNamesArr([])
            }
        }
    };
    const isDeviceIncludes = (deviceArr: string[], input: string): void => {
        if (deviceArr.includes(input)) {
            const messageBody: IMessageSender = {
                type: 'getAssetInfo',
                userId: auth.username,
                assetInfo: {
                    assetName: input
                }
            }
            axios.post('/message', messageBody, auth.header
            ).then(({data}: { data: IMessageResponse }) => {
                if (data.status === "OK") {
                    let assetInfo = data.assetInfo
                    console.log(assetInfo);
                    if (assetInfo.loadSensorId && assetInfo.loadSensorId !== "") {
                        setFormInput({
                            assetName: input,
                            deviceId: ""
                        })
                        setSensorIdArr([assetInfo.deviceId, assetInfo.loadSensorId])
                        setFormFieldsValid({
                            isVaild: false,
                            displayMessage: false,
                            message: ""
                        })
                    } else {
                        setSensorIdArr([])
                        setFormInput({
                            assetName: input,
                            deviceId: assetInfo.deviceId
                        })
                        setFormFieldsValid({
                            isVaild: true,
                            displayMessage: false,
                            message: ""
                        })
                    }
                    // setFormInput({
                    //     ...formInput,
                    //     ...assetInfo
                    // })

                } else {
                    // setFormFieldsValid({
                    //     ...formFieldsValid,
                    //     [type]:{
                    //         displayMessage: true,
                    //         message: data.errorDescription
                    //       }
                    // })
                }
            }).catch(({response}: IMessageErrorResponse) => {
                const errorMessage = errorHandler(response.data.status)
                setErrorMessage(errorMessage)
                setDisplayMessage("error");
            })
        }
    }
    return (
        <div className='page-template' onClick={navBarClickHandler}>
            <HeaderTemplate title="Replace Batteries"/>
            <div
                className={(displayMessage !== "none" || isNavbarOpen === true) ? 'page-template-main blur' : 'page-template-main'}
                onClick={navBarClickHandler}>
                <form className="form-template" onSubmit={submitHandler}>
                    <div className='form-template-top-container'>
                        <div className='replace-batteries-data'>
                            To reset battery consumption calculations, let us know that you've changed sensor's
                            batteries
                        </div>
                        < FormInternalDivTemplate
                            id="assetName"
                            label="Asset Name"
                            type="list"
                            value={formInput.assetName}
                            maxLength={32}
                            // displayMessage={formFieldsValid.assetName.displayMessage}
                            // message={formFieldsValid.assetName.message}
                            onChange={assetNameChangeHandler}
                            listId="assetsNamesId"
                            array={assetNamesArr}
                            disabled={isDisabled()}
                        />
                        < FormInternalDivTemplate
                            id="sensorId"
                            label="Sensor ID *"
                            type="list"
                            value={formInput.deviceId}
                            maxLength={8}
                            displayMessage={formFieldsValid.displayMessage}
                            message={formFieldsValid.message}
                            onChange={changeHandler}
                            listId="loadSensorsId"
                            array={sensorIdArr}
                            disabled={isDisabled()}
                        />
                    </div>
                    <div className='form-template-div-button-one-field'>
                        <button type="submit" className="submit-form-btn" disabled={isDisabled()}>
                            Batteries Replaced
                        </button>
                    </div>
                </form>
            </div>
            {displayMessage !== "none" &&
                <div className='page-template-pop-message'>
                    <PopMessage
                        assetHandler={replaceBatteriesHandler}
                        formData={{sensorId: formInput.deviceId}}
                        type={"general"}
                        error={errorMessage}
                    />
                </div>
            }
        </div>
    );
}

export default ReplaceBatteries;

